var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-area',{ref:"addForm",staticClass:"content md",attrs:{"layout":"horizontal","label-col":{span: 4},"wrapper-col":{span: 20},"items":_vm.items,"entity":_vm.form},on:{"cancel":_vm.handleCancel,"confirm":_vm.handleConfirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }